/**
 * カレンダー表示時に、現在時刻が見える位置までスクロールする
 *
 * 週ビュー・日ビューともタイムグリッド自体はスクロールせず、Todo ページ外側の領域がスクロールするため、
 * その領域の scrollTop を直接合わせる。
 */

/** 現在時刻の線をスクロール領域の上からこの割合の位置に置く（上の固定ヘッダーに隠れないように） */
const NOW_LINE_RATIO = 1 / 3

type ScrollTopParams = {
  /** スクロール領域の現在の scrollTop */
  scrollTop: number
  /** スクロール領域の表示部分の高さ */
  clientHeight: number
  /** スクロール領域の上端（ビューポート座標） */
  scrollerTop: number
  /** 0:00〜24:00 のグリッドの上端（ビューポート座標） */
  gridTop: number
  /** 0:00〜24:00 のグリッドの高さ */
  gridHeight: number
  now: Date
}

export const calcScrollTopForNow = ({
  scrollTop,
  clientHeight,
  scrollerTop,
  gridTop,
  gridHeight,
  now,
}: ScrollTopParams): number => {
  const minutes = now.getHours() * 60 + now.getMinutes()
  const nowY = gridTop + (gridHeight * minutes) / (24 * 60)
  return Math.max(0, scrollTop + (nowY - scrollerTop) - clientHeight * NOW_LINE_RATIO)
}

const findScrollParent = (el: HTMLElement): HTMLElement | null => {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node)
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node
  }
  return null
}

/** grid は 0:00〜24:00 をちょうど覆う要素 */
export const scrollToNow = (grid: HTMLElement, now: Date = new Date()) => {
  const parent = findScrollParent(grid)
  const scroller = parent ?? document.scrollingElement
  if (!scroller) return
  scroller.scrollTop = calcScrollTopForNow({
    scrollTop: scroller.scrollTop,
    clientHeight: scroller.clientHeight,
    scrollerTop: parent ? parent.getBoundingClientRect().top : 0,
    gridTop: grid.getBoundingClientRect().top,
    gridHeight: grid.offsetHeight,
    now,
  })
}
